import React from "react";

const Partners = ({ data }) => {
  return (
    <div className="">
      <div className="container">
        <h2 className="text-center paragraph-lg text-gray-600 mb-6">
          {data.title}
        </h2>
        <div className="flex items-center justify-between sm:justify-center gap-y-6 gap-16 lg:gap-4 lmd:flex-wrap w-full">
          {data.images.map(({ src }, index) => (
            <img
              key={index}
              src={src}
              className={`!max-h-20 !object-contain flex-1 w-full sm:w-2/5`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
